// extracted by mini-css-extract-plugin
export default {"link":"link-iWQYDA16vtigvtKABOH_","outlined":"outlined-VkZQ5wykq3ag2KOSR9RP"};